import { I18n } from '@calendly/i18n';
import { FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { IconArrowsMaximize } from '@calendly/ui/components/glyphs/IconArrowsMaximize';
import { IconCreditCard } from '@calendly/ui/components/glyphs/IconCreditCard';
import { IconDeviceMobile } from '@calendly/ui/components/glyphs/IconDeviceMobile';
import { IconMail } from '@calendly/ui/components/glyphs/IconMail';
import { IconPencil } from '@calendly/ui/components/glyphs/IconPencil';
import { IconWorld } from '@calendly/ui/components/glyphs/IconWorld';
import { IconButton } from '@calendly/ui/components/icon-button';
import { Link } from '@calendly/ui/components/link';
import { HeadlineText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorIconStandard, colorTextAction } from '@calendly/ui/theme';
import { ParamRow } from '../utm_params_widget';
import { MeetingPackageContactRow } from './meeting_package_contact_row';
import { iconWrapperCss, Row } from './styles';
const arrowExpandIconCss = "anmz9iy";
export const ContactDetailRows = ({
  email,
  phoneNumber,
  timezone,
  paymentInfo,
  paymentLink,
  canEditEmail,
  openEditEmailModal,
  packageInfo,
  trackingParams = [],
  viewPackage
}) => <>
      <MeetingPackageContactRow packageInfo={packageInfo} viewPackage={viewPackage} />
      <Row>
        <span className={iconWrapperCss}>
          <UiIcon icon={IconMail} size="small" spacingRight="0" />
        </span>
        <FullStoryMask>{email}</FullStoryMask>
        {canEditEmail && <IconButton size="small" title={I18n.t('publisher.action.edit')} aria-label={I18n.t('publisher.action.edit')} onClick={openEditEmailModal}>
          <HeadlineText color={colorTextAction}>
            <UiIcon icon={IconPencil} size="small" />
          </HeadlineText>
        </IconButton>}
      </Row>
      {phoneNumber && <Row>
        <span className={iconWrapperCss}>
          <UiIcon icon={IconDeviceMobile} size="small" spacingRight="0" />
        </span>
        <FullStoryMask>{phoneNumber}</FullStoryMask>
      </Row>}
      {timezone && <Row>
        <span className={iconWrapperCss}>
          <UiIcon icon={IconWorld} size="small" spacingRight="0" />
        </span>
        <span>{timezone}</span>
      </Row>}
      {trackingParams.map(({
    label,
    value
  }) => <ParamRow key={label} label={label} value={value} iconWrapperClassName={iconWrapperCss} />)}
      {paymentInfo && <Row>
        <span className={iconWrapperCss}>
          <UiIcon icon={IconCreditCard} size="small" spacingRight="0" />
        </span>
        <FullStoryMask>{paymentInfo}</FullStoryMask>
        {paymentLink && <Link href={paymentLink} target="_blank" rel="noopener noreferrer" underline={false} className={arrowExpandIconCss}>
            <UiIcon icon={IconArrowsMaximize} size="small" color={colorIconStandard} />
          </Link>}
      </Row>}
    </>;

require("./contact_detail_rows.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./contact_detail_rows.js");